<script lang="ts">
  // components
  import NoPaymentMethodBanner from "@retailer/svelte/Payments/Banners/NoPaymentMethod.svelte";
  import PastDueDateBanner from "@retailer/svelte/Payments/Banners/PastDueDate.svelte";

  // stores
  import { userReactivated } from "@retailer/svelte/stores/DwollaIdentityStore";
  import { paymentInstrumentsStore } from "@retailer/svelte/stores/PaymentInstrumentStore";

  export let singleInvoice: boolean = false;
  export let showNotPayableError: boolean = false;
  export let showWarning: boolean = false;

  $: noPaymentMethods = $paymentInstrumentsStore.paymentInstruments.length == 0;

</script>

{#if $userReactivated && noPaymentMethods}
  <NoPaymentMethodBanner />
{:else if showNotPayableError}
  <PastDueDateBanner {singleInvoice} level={"error"} />
{:else if showWarning}
  <PastDueDateBanner {singleInvoice} level={"warning"} />
{/if}
